import axios from 'axios'
import router from '@/router'


// export const baseURLProtocol = 'http'
// export const baseURLIp = '192.168.0.200'
// export const baseURLPort = '8082'
// // export const baseH5URLPort = '8100'
// export const appVersion = '1.0.0'

export const baseURLProtocol = 'https'
export const baseURLIp = 'www.nbymzj.com'
export const baseURLPort = '8082'
// export const baseH5URLPort = ''
export const appVersion = '1.0.0'

axios.defaults.baseH5URL = baseURLProtocol + '://' + baseURLIp + '/'//+ ':' + baseH5URLPort

axios.defaults.baseURL = baseURLProtocol + '://' + baseURLIp + ':' + baseURLPort + '/'
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.post['Content-Type'] = 'application/json'

axios.interceptors.request.use(config => {
  const user = localStorage.getItem('user');
  const userId = user && user !== 'null' ? JSON.parse(user).id : null;
  config.params = config.params || {};
  config.params.userId = userId;
  return config;
});


axios.interceptors.response.use(
  res => { // 302
    return res.data
  }, error => {
    if (error.response) {
      console.log(error.response)
    } else {
      router.push('/login').then()
    }
    return Promise.reject(error)
  }
)

export default axios

